import { render, staticRenderFns } from "./service_component.vue?vue&type=template&id=4ed3a896&scoped=true&"
import script from "../../assets/customer/js/singleservice.js?vue&type=script&lang=js&"
export * from "../../assets/customer/js/singleservice.js?vue&type=script&lang=js&"
import style0 from "./service_component.vue?vue&type=style&index=0&id=4ed3a896&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ed3a896",
  null
  
)

export default component.exports